module.exports = __webpack_public_path__ + "img/bg-masthead.622ec603.png";